import React from 'react';
import { Plus } from 'lucide-react';
import { Link } from 'react-router-dom';

interface FloatingActionButtonProps {
  to: string;
  icon?: React.ReactNode;
  onClick?: () => void;
}

const FloatingActionButton: React.FC<FloatingActionButtonProps> = ({ 
  to, 
  icon = <Plus size={24} />, 
  onClick 
}) => {
  if (onClick) {
    return (
      <button 
        className="fab"
        onClick={onClick}
        aria-label="Add new"
      >
        {icon}
      </button>
    );
  }
  
  return (
    <Link 
      to={to} 
      className="fab"
      aria-label="Add new"
    >
      {icon}
    </Link>
  );
};

export default FloatingActionButton;